export default __webpack_public_path__ + "static/media/05_photo.d38ba696.jpg";